module.exports = __webpack_public_path__ + "img/points.df9f1ddd.png";